import { useEffect } from "react";
import { SERVER_URL } from "../../../config/config";
import { SSE_HEADER } from "../../../constants/sse";
import { parseNewCrimeInfo } from "../../../helper/game";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getJailList } from "../../../reducers/jail.slice";
import { getMyProfile } from "../../../reducers/profile.slice";

const useJailSSE = (
  account: string,
  onSuccess: (successXpAmount: number) => void,
  onCaught: () => void,
  onFailed: () => void
) => {
  const dispatch = useAppDispatch();
  const { myProfile } = useAppSelector((state) => state.profile);

  useEffect(() => {
    const crimeEventSource = new EventSource(`${SERVER_URL}/event/crime`);
    crimeEventSource.onmessage = (e) => {
      if (e.data.includes("welcome")) {
        console.log("welcome event");
      } else if (e.data.includes("eventName")) {
        const event = JSON.parse(e.data);

        if (event.eventName === SSE_HEADER.CRIME.NEW_CRIME) {
          const crimeInfo = parseNewCrimeInfo(event.data);

          if (crimeInfo.isJailed) {
            dispatch(getJailList());
          }
        }
      }
    };

    const jailEventSource = new EventSource(`${SERVER_URL}/event/jail`);
    jailEventSource.onmessage = (e) => {
      if (e.data.includes("welcome")) {
        console.log("welcome event");
      } else if (e.data.includes("eventName")) {
        const event = JSON.parse(e.data);

        if (
          event.eventName === SSE_HEADER.JAIL.BUST_OUT_PRISONER ||
          event.eventName === SSE_HEADER.JAIL.BUY_OUT_PRISONER
        ) {
          dispatch(getJailList());
          myProfile.name && dispatch(getMyProfile(myProfile.name));
        }

        if (event.eventName === SSE_HEADER.JAIL.BUST_OUT_PRISONER) {
          if (event.data.buster.toLowerCase() !== account.toLowerCase()) return;

          if (event.data.isSuccess) {
            onSuccess(parseInt(event.data.xpPoint));
          } else if (event.data.isJailed) {
            onCaught();
          } else if (!event.data.isSuccess && !event.data.isJailed) {
            onFailed();
          }
        }
      }
    };

    return () => {
      crimeEventSource.close();
      jailEventSource.close();
    };
  }, [account, dispatch, myProfile.name, onCaught, onFailed, onSuccess]);
};

export default useJailSSE;
